import { SxProps, SystemStyleObject, Theme } from '@mui/system'

/**
 * Compose multiple SystemStyleObject layers into a single sx prop value, in order
 * (later layers win on conflicting keys). Undefined layers are skipped.
 *
 * Used by the Custom* wrapper components to merge their internal styling with
 * caller-supplied `sx` (and the transitional `styles`) without the caller
 * clobbering the wrapper's defaults.
 */
export function composeSx(...layers: Array<SystemStyleObject<Theme> | undefined>): SxProps<Theme> {
  return layers.filter((layer): layer is SystemStyleObject<Theme> => Boolean(layer))
}
